const API_ROOT = window.PEACE_API_ROOT || '/conceptxx/elect/peace/play/api/';

function lower(value) {
  if (Array.isArray(value)) return value.map(lower);
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [key.toLowerCase(), lower(item)]));
  }
  return value;
}

async function parseResponse(response) {
  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    throw new Error(`The server returned ${response.status} instead of game data.`);
  }
  const data = lower(await response.json());
  if (!response.ok || data.ok === false) {
    throw new Error(data.error || data.message || 'The game service could not complete the request.');
  }
  return data;
}

export class ExperienceApi {
  constructor(csrf = '') {
    this.csrf = csrf;
  }

  async bootstrap(program, scenario, preview = '', as = '') {
    const query = new URLSearchParams({ program, scenario, v: String(Date.now()) });
    // a scene with more than one version (It's on you / Help your friend): which one to load
    if (as) query.set('as', as);
    // a signed test link (?preview=...) asks the server for the scenario's unpublished draft
    if (preview) query.set('preview', preview);
    // test links only: &place=<location key> tries the scene at another location (a 3D world)
    const place = new URLSearchParams(window.location.search).get('place');
    if (preview && place && /^[a-z0-9_]{1,80}$/.test(place)) query.set('place', place);
    const response = await fetch(`${API_ROOT}bootstrap.cfm?${query}`, {
      credentials: 'same-origin',
      cache: 'no-store'
    });
    const data = await parseResponse(response);
    this.csrf = data.csrf || this.csrf;
    return data;
  }

  async post(endpoint, body = {}) {
    const response = await fetch(`${API_ROOT}${endpoint}.cfm`, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        'X-Peace-CSRF': this.csrf
      },
      body: JSON.stringify(body)
    });
    return parseResponse(response);
  }

  start(payload) { return this.post('start', payload); }
  register(payload) { return this.post('register', payload); }
  event(payload) { return this.post('event', payload); }
  voice(payload) { return this.post('voice', payload); }
  respond(payload) { return this.post('respond', payload); }
  turn(payload) { return this.post('turn', payload); }
  flag(payload) { return this.post('flag', payload); }
  leaderboard() { return this.post('leaderboard', {}); }
  offers() { return this.post('offers', {}); }
  claimOffer(offerId) { return this.post('claim_offer', { offerId }); }
}
